import React, { useEffect } from 'react';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BonusSection } from './components/BonusSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1086781087036952');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="356rv4texg92">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1086781087036952&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="34nbhsjeuzx5" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-warm text-navy" data-id="element-2" data-mp="d2bhxfqdpvv5">
        <main data-id="element-3" data-mp="86cqfj9r7xqi">
          <Hero data-id="element-4" data-mp="83qj9kqrzk8t" />
          <ProblemSection data-id="element-5" data-mp="3gl4rlhg1e0k1" />
          <SystemSection data-id="element-6" data-mp="3gmfulf1nr4a3" />
          <ModulesSection data-id="element-7" data-mp="3glo067jsrcle" />
          <PreviewCarousel data-id="element-8" data-mp="3bmbe3p0r29jv" />
          <BonusSection data-id="element-9" data-mp="3bn2xm1h2ogts" />
          <DifferentiatorSection data-id="element-10" data-mp="3bnmk7vho3te5" />
          <Offer data-id="element-11" data-mp="3bkgss9lkgff9" />
          <Guarantee data-id="element-12" data-mp="3qaxt1pmgszak" />
          <Testimonials data-id="element-13" data-mp="3qbfztg6r6vwq" />
          <FAQ data-id="element-14" data-mp="3qcqy50hfjbgg" />
          <FinalCTA data-id="element-15" data-mp="3qdai0mqn49x4" />
        </main>
        <Footer data-id="element-16" data-mp="3ljxvci5iud70" />
        {showPurchasePopup && <PurchaseToast data-id="element-17" data-mp="3liwjwcklfoor" />}
      </div>
    </>;
}